import type { IconData } from '@stacksjs/iconify-core'

export const browse: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 4v10h16V4zm1-1a1 1 0 1 0 0-2a1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2M2 0h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 20,
  "height": 16,
  "viewBox": "0 0 20 16"
}

export default browse
